import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

// Route name mappings in French
const ROUTE_NAMES = {
  'app': 'Accueil',
  'feed': 'Fil d\'actualité',
  'discover': 'Découvrir',
  'profile': 'Profil',
  'messages': 'Messages',
  'dashboard': 'Tableau de bord',
  'assistant': 'Assistant IA',
  'communities': 'Communautés',
  'shop': 'Boutique',
  'booking': 'Réservation',
  'settings': 'Paramètres',
  'notifications': 'Notifications'
};

const Breadcrumbs = ({ customItems, className = '' }) => {
  const location = useLocation();
  
  // Parse current path
  const pathParts = location.pathname.split('/').filter(Boolean);
  
  // Build breadcrumb items
  const items = customItems || pathParts.map((part, index) => {
    const path = '/' + pathParts.slice(0, index + 1).join('/');
    
    // Skip user IDs and other dynamic segments
    if (part.startsWith('user_') || part.startsWith('community_') || part.startsWith('product_')) {
      return null;
    }
    
    const name = ROUTE_NAMES[part] || part.charAt(0).toUpperCase() + part.slice(1);
    const isLast = index === pathParts.length - 1;
    
    return { name, path, isLast };
  }).filter(Boolean);

  // Don't render if only one item or empty
  if (items.length <= 1) return null;

  return (
    <nav 
      className={`flex items-center text-sm text-gray-500 mb-4 ${className}`}
      aria-label="Breadcrumb"
    >
      <ol className="flex items-center space-x-1">
        {/* Home link */}
        <li>
          <Link 
            to="/app/feed" 
            className="flex items-center hover:text-purple-600 transition-colors"
          >
            <Home className="h-4 w-4" />
          </Link>
        </li>
        
        {items.map((item, index) => (
          <li key={item.path} className="flex items-center">
            <ChevronRight className="h-4 w-4 mx-1 text-gray-400" />
            {item.isLast ? (
              <span className="font-medium text-gray-900">
                {item.name}
              </span>
            ) : (
              <Link 
                to={item.path}
                className="hover:text-purple-600 transition-colors"
              >
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
